var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTerms(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 21,
    viewBox: "0 0 19 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.87182 1.87493C10.7548 1.28121 11.6963 0.984347 12.5166 1.00064C14.2319 1.0347 15.8099 1.94576 16.697 3.41418C17.1213 4.11646 17.3349 5.08025 17.7623 7.00783C17.9282 7.75645 18.0112 8.13076 18.0371 8.50123C18.0908 9.26813 17.9669 10.0371 17.6751 10.7483C17.5341 11.0919 17.3378 11.4212 16.9451 12.0798L14.4869 16.2027C13.5956 17.6976 13.1499 18.4451 12.6006 18.9449C11.3849 20.0511 9.70312 20.4891 8.10226 20.1165C7.37889 19.9481 6.62522 19.513 5.11788 18.6427C3.61054 17.7725 2.85687 17.3373 2.34938 16.7951C1.22628 15.595 0.764722 13.9196 1.1148 12.3136C1.27299 11.588 1.6975 10.8283 2.54651 9.30885L4.88793 5.11862C5.26197 4.44924 5.44899 4.11455 5.67605 3.82067C6.14608 3.21233 6.75007 2.72056 7.44106 2.3836C7.77486 2.22082 8.14052 2.10552 8.87182 1.87493Z",
    stroke: "black",
    strokeWidth: 1.3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.9931 6.63122C9.53747 7.4204 9.80786 8.42953 10.597 8.88516C11.3862 9.3408 12.3953 9.0704 12.851 8.28122C13.3066 7.49204 13.0362 6.48291 12.247 6.02728C11.4579 5.57164 10.4487 5.84204 9.9931 6.63122Z",
    stroke: "black",
    strokeWidth: 1.3
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTerms);
export default __webpack_public_path__ + "static/media/terms.c02e13c0fb9d130e06888e44a59e5421.svg";
export { ForwardRef as ReactComponent };